import { createSlice } from "@reduxjs/toolkit";

const navigation = createSlice({
  name: "navigation",
  initialState: {
    pageCounter: "",
    linkStepValue: false,
    isErrorPage: false,
  },
  reducers: {
    navigationStep(state, { payload }) {
      state.pageCounter = payload;
    },
    linkStep(state, { payload }) {
      state.linkStepValue = payload;
    },
    setIsErrorPage(state, { payload }) {
      state.isErrorPage = payload;
    },
  },
});
export const { linkStep, navigationStep, setIsErrorPage } = navigation.actions;
export default navigation.reducer;
